import IGenericResult from "../interfaces/IGenericResult";
import ILancamentoManual from "../interfaces/ILancamentoManual";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class LancamentoManualService {
    async getAllInstalacoes() {
        return await api.get<IGenericResult[]>(`${resources.lancamentoManual}/GetAllInstalacoes`);
    }

    async getMotivosByCategoria(data: any) {
        return await api.get<IGenericResult[]>(
            `${resources.lancamentoManual}/GetMotivosByCategoria/${ToQueryString(data)}`
        );
    }

    async create(data: any) {
        return await api.post<ILancamentoManual>(`${resources.lancamentoManual}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.lancamentoManual}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.lancamentoManual}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.lancamentoManual}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async upload(data: any) {
        return await api.post(`${resources.lancamentoManual.toLowerCase()}/upload`, data);
    }
}

export default new LancamentoManualService();
